// extracted by mini-css-extract-plugin
export var container = "Facts-module--container--1VNER";
export var elementsWrapper = "Facts-module--elementsWrapper--32RGd";
export var element = "Facts-module--element--1oQ_w";